import { Role } from '@obtainly/bootstrap';
export var ledgerPermissions = [
    { id: 'view_ledgers', roles: [Role.DistributorStaff] },
    { id: 'create_ledger', roles: [Role.DistributorStaff] },
    { id: 'update_ledger', roles: [Role.DistributorStaff] },
];
export * from './utils/ledger';
export * from './components';
